import React from 'react'

import cn from '../../libs/class-names'

export type Position = 'none' | 'top' | 'bottom' | 'left' | 'right'

const getTransform = (position: Position, shift: number) => {
  switch (position) {
    case 'left':
      return `translateY(${-shift}px)`
    case 'right':
      return `translateY(${-shift}px)`
    case 'bottom':
      return `translateX(${-shift}px)`
    default:
      return `translateX(${-shift}px)`
  }
}

export interface Props {
  classNames?: string[]
  children: React.ReactNode
  footer?: React.ReactNode
  position?: Position
  shift?: number
  block?: boolean
  appearance?: 'light' | 'dark'
}

const Tooltip = ({
  classNames,
  children,
  footer,
  position = 'none',
  shift = 0,
  block = false,
  appearance = 'light',
}: Props) => (
  <div
    className={cn(
      'Tooltip',
      {[`position-${position}`]: true, block, [`appearance-${appearance}`]: true},
      classNames
    )}
  >
    <div className="Tooltip__main">
      <div className="Tooltip__content">{children}</div>
      {footer && <div className="Tooltip__footer">{footer}</div>}
    </div>
    {position !== 'none' && (
      <div
        className="Tooltip__arrow"
        style={{
          transform: getTransform(position, shift),
        }}
      />
    )}
  </div>
)

export default Tooltip
